// Sprint 2 — Reorganización de configuración
import { motion, AnimatePresence } from "motion/react";
import { useState, type ReactNode } from "react";
import { css } from "styled-system/css";

const PLAN_ORDER = ["FREE", "PRO", "ENTERPRISE"] as const;

function planIndex(p: string): number {
  const i = PLAN_ORDER.indexOf(p as (typeof PLAN_ORDER)[number]);
  return i >= 0 ? i : 0;
}

function meetsPlan(required: "advance" | "pro", currentPlan: string): boolean {
  const idx = planIndex(currentPlan);
  if (required === "advance") return idx >= planIndex("PRO");
  return idx >= planIndex("ENTERPRISE");
}

type Props = {
  planRequired: "advance" | "pro";
  currentPlan: string;
  children: ReactNode;
};

export function ProFeature({ planRequired, currentPlan, children }: Props) {
  const [hover, setHover] = useState(false);
  const ok = meetsPlan(planRequired, currentPlan);
  const label = planRequired === "advance" ? "Pro" : "Enterprise";
  const planName = planRequired === "advance" ? "Pro" : "Enterprise";

  if (ok) return <>{children}</>;

  return (
    <div
      className={css({ position: "relative" })}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div
        className={css({
          pointerEvents: "none",
          opacity: 0.55,
          filter: "grayscale(0.15)",
        })}
      >
        {children}
      </div>
      <span
        className={css({
          position: "absolute",
          top: "2",
          right: "2",
          fontSize: "10px",
          fontWeight: "bold",
          textTransform: "uppercase",
          letterSpacing: "wider",
          px: "2",
          py: "0.5",
          rounded: "md",
          bg: "token(colors.brand.600)",
          color: "white",
          zIndex: 2,
          pointerEvents: "none",
        })}
      >
        {label}
      </span>
      <AnimatePresence>
        {hover ? (
          <motion.div
            initial={{ opacity: 0, y: 4 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 4 }}
            transition={{ duration: 0.15 }}
            className={css({
              position: "absolute",
              bottom: "calc(100% + 6px)",
              right: "0",
              maxW: "220px",
              px: "3",
              py: "2",
              rounded: "md",
              fontSize: "xs",
              lineHeight: "1.4",
              bg: "#0f172a",
              color: "white",
              boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
              zIndex: 5,
              pointerEvents: "none",
            })}
          >
            Disponible en el plan {planName}.
          </motion.div>
        ) : null}
      </AnimatePresence>
    </div>
  );
}
